<template>
  <main>
    <header>
      <div class="header-kv">
        <img src="@/assets/Xmas/img/banner_bg2.png" alt="">
        <h2 id="myTargetElement" class="jumbo">
          {{ prize | comma }}
        </h2>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❆
        </div>
        <div class="snowflake">
          ❄
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❆
        </div>
        <div class="snowflake">
          ❄
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❆
        </div>
        <div class="snowflake">
          ❄
        </div>
      </div>
      <div class="header-text">
        <h3>Description</h3>
        <ul>
          <li>Conditions of participation : Reaching the <em>VIP 1 up </em>, Register manually on the bonus center. </li>
          <li>Game : Slot</li>
        </ul>
      </div>
    </header>

    <section class="ranking">
      <div v-if="(members.length > 3)">
        <div class="ranking-top3">
          <img src="@/assets/Xmas/img/banner_bg_rank.png" alt="">
          <div class="top3-flex top2">
            <div class="top3-text">
              <p class="top3-account">
                {{ members[1][1] }}
              </p>
              <p class="top3-number top3-number-middle">
                t.o. {{ members[1][3] | comma }}
              </p>
              <p class="top3-number top3-number-below">
                <span style="font-weight: 100">₱</span>{{ members[1][4] }}
              </p>
            </div>
          </div>

          <div class="top3-flex top1">
            <div class="top3-text">
              <p class="top3-account">
                {{ members[0][1] }}
              </p>
              <p class="top3-number top3-number-middle">
                t.o. {{ members[0][3] | comma }}
              </p>
              <p class="top3-number top3-number-below">
                <span style="font-weight: 100">₱</span>{{ members[0][4] }}
              </p>
            </div>
          </div>

          <div class="top3-flex top3">
            <div class="top3-text">
              <p class="top3-account">
                {{ members[2][1] }}
              </p>
              <p class="top3-number top3-number-middle">
                t.o. {{ members[2][3] | comma }}
              </p>
              <p class="top3-number top3-number-below">
                <span style="font-weight: 100">₱</span>{{ members[2][4] }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="ranking-out3">
        <div class="out3-flex" :style="{ 'height' : showMore ? 'auto' : ''}">
          <div v-for="(item, key) in members.slice(3, 50)" :key="key" class="out3-item">
            <h5 class="out3-num">
              {{ key + 4 }}
            </h5>

            <div class="out3-text">
              <p class="out3-account">
                {{ item[1] }}
              </p>
              <p class="out3-number out3-number-middle">
                t.o. {{ item[3] | comma }}
              </p>
              <p class="out3-number out3-number-below">
                <span style="font-weight: 100">₱</span>{{ item[4] }}
              </p>
            </div>
          </div>
        </div>

        <div class="out3-more" @click="showMore = true">
          <p>View More</p>
          <div class="more-arrow">
            <img src="@/assets/Xmas/img/arrow_down.svg" alt="">
          </div>
        </div>
      </div>
    </section>

    <div class="lightbulb-bg">
      <img src="@/assets/Xmas/img/banner_bg_pool.png" alt="">
    </div>
    <div class="pool-text">
      <h3>Accumulated bonus pool</h3>
      <div>Every participant plays slot game which <em>0.6%</em> of each bet will continue to accumulate into the total bonus pool.</div>
    </div>

    <div class="price-ranking-bg">
      <img src="@/assets/Xmas/img/banner_bg_prize_rank.png" alt="">
    </div>

    <div class="news-bg">
      <img src="@/assets/Xmas/img/banner_bg_news.png" alt="">
      <img class="btn" src="@/assets/Xmas/img/news-bg-btn.svg" alt="" @click="goInvite()">
    </div>

    <a v-if="$route.path === '/Xmas'" href="https://www.bonus365.io/event/56" class="back">
      <div class="back-btn">
        Back to Bonus365
      </div>
      <div class="more-arrow">
        <img src="@/assets/Xmas/img/arrow_left.png" alt="">
      </div>
    </a>
    <a v-if="$route.path === '/Xmas2'" href="https://www.bonus365.io/event/57" class="back">
      <div class="back-btn">
        Back to Bonus365
      </div>
      <div class="more-arrow">
        <img src="@/assets/Xmas/img/arrow_left.png" alt="">
      </div>
    </a>
    <a v-if="$route.path === '/Xmas3'" href="https://www.bonus365.io/event/58" class="back">
      <div class="back-btn">
        Back to Bonus365
      </div>
      <div class="more-arrow">
        <img src="@/assets/Xmas/img/arrow_left.png" alt="">
      </div>
    </a>
    <a v-if="$route.path === '/Xmas4'" href="https://www.bonus365.io/event/70" class="back">
      <div class="back-btn">
        Back to Bonus365
      </div>
      <div class="more-arrow">
        <img src="@/assets/Xmas/img/arrow_left.png" alt="">
      </div>
    </a>
    <a v-if="$route.path === '/Xmas5'" href="https://www.bonus365.io/event/71" class="back">
      <div class="back-btn">
        Back to Bonus365
      </div>
      <div class="more-arrow">
        <img src="@/assets/Xmas/img/arrow_left.png" alt="">
      </div>
    </a>
    <a v-if="$route.path === '/Xmas6'" href="https://www.bonus365.io/event/72" class="back">
      <div class="back-btn">
        Back to Bonus365
      </div>
      <div class="more-arrow">
        <img src="@/assets/Xmas/img/arrow_left.png" alt="">
      </div>
    </a>

    <footer>
      <img src="@/assets/Xmas/img/banner_bg3.png" alt="">
    </footer>
  </main>
</template>

<script>
import('@/assets/Xmas/css/style.css')
import { CountUp } from 'countup.js'

export default {
  filters: {
    comma: function(value) {
      return Math.round(Number(value)).toLocaleString()
    },
    commaFlaot: function(value) {
      return Number(value).toFixed(2).toLocaleString()
    }
  },
  data() {
    return {
      prize: 0,
      maxPrize: 0,
      members: [],
      showMore: false
    }
  },
  mounted() {
    let api_base_url = 'https://event.bonus365.io/xmas/56'
    if (this.$route.path === '/Xmas2') {
      api_base_url = 'https://event.bonus365.io/xmas/57'
    } else if (this.$route.path === '/Xmas3') {
      api_base_url = 'https://event.bonus365.io/xmas/58'
    } else if (this.$route.path === '/Xmas4') {
      api_base_url = 'https://event.bonus365.io/xmas/70'
    } else if (this.$route.path === '/Xmas5') {
      api_base_url = 'https://event.bonus365.io/xmas/71'
    } else if (this.$route.path === '/Xmas6') {
      api_base_url = 'https://event.bonus365.io/xmas/72'
    }
    var self = this
    fetch(api_base_url)
      .then(function(response) {
        return response.json()
      })
      .then(function(myJson) {
        self.prize = myJson.basePrize
        self.maxPrize = myJson.prize
        self.members = myJson.members
        if (self.members.length < 50) {
          const start = self.members.length
          for (let i = start; i < 50; i++) {
            self.members[i] = [
              0,
              '*************',
              0,
              0,
              0
            ]
          }
        }

        const easingFn = function(t, b, c, d) {
          var ts = (t /= d) * t
          var tc = ts * t
          return b + c * (tc + -3 * ts + 3 * t)
        }
        const options = {
          startVal: self.prize,
          duration: 2.5,
          easingFn
        }
        const demo = new CountUp('myTargetElement', self.maxPrize, options)
        if (!demo.error) {
          demo.start()
        } else {
          console.error(demo.error)
        }
      })
  },
  methods: {
    myFunction() {
      if (this.prize >= this.maxPrize) {
        return false
      } else {
        this.prize += 1
        const min = 1
        const max = 100
        const rand = Math.floor(Math.random() * (max - min + 1) + min)
        setTimeout(() => { this.myFunction() }, rand * 10)
      }
    },
    goInvite() {
      window.location.href = 'https://www.bonus365.ph/user/friend'
    }
  }
}
</script>
